import { useState, useEffect } from 'react';

import { pathQueryParams } from '../../../constants/pathQueryParams';
import { challengeSignUpService } from '../../../services/challengeSignUpService';
import { ChallengeSignUpEntityData } from '../../../interfaces/ChallengeSignUpEntityData';
import { getRouteParam } from '../../../../shared/utils/angularUtils';

type UseEntityDataReturn = {
  entityData: ChallengeSignUpEntityData | null;
};

export const useEntityData = (): UseEntityDataReturn => {
  const [entityData, setEntityData] = useState<ChallengeSignUpEntityData | null>(null);

  const getEntityData = async () => {
    const challengeId = getRouteParam(pathQueryParams.challengeId);

    if (!challengeId) {
      throw new Error('Challenge ID is not defined');
    }

    const response =
      await challengeSignUpService.getChallengeSignUpEntityData(challengeId);

    setEntityData(response);
  };

  useEffect(() => {
    getEntityData();
  }, []);

  return {
    entityData,
  };
};
